export default __webpack_public_path__ + "static/media/english-to-russian-logo.b7ea59bc.png";